import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import { createResume } from "../../store/actions/resumeActions";
import ResumeList from "./ResumeList";

class ViewResumes extends Component {
  render() {
    const { auth, resumes } = this.props;
    if (!auth.uid) return <Redirect to="/" />;
    return (
      <div className="container">
        <h5 className="page-title">私の履歴書</h5>
        <div className="col s12 m6">
            <ResumeList resumes={resumes} />
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    resumes: state.firestore.ordered.resumes
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "resumes" }])
)(ViewResumes);
